module.exports = __webpack_public_path__ + "img/9_17.fe7ca916.png";